import { createSlice } from "@reduxjs/toolkit";
import { OrganisationDto } from "../api";

const priorityOrganisationOrder = new Map<number, number>([
    [0, 0],
    [6, 1],
    [40094, 2],
]);

function sortOrganisations(organisations: OrganisationDto[]) {
    return [...organisations].sort((first, second) => {
        const firstPriority = priorityOrganisationOrder.get(first.id!) ?? Number.MAX_SAFE_INTEGER;
        const secondPriority = priorityOrganisationOrder.get(second.id!) ?? Number.MAX_SAFE_INTEGER;

        return firstPriority - secondPriority;
    });
}

 const initialState: { organisations: OrganisationDto[] | null } = {
     organisations: null
 };

 const organisationSlice = createSlice({
     name: 'organisationSlice',
     initialState,
     reducers: {
         setOrganisations: (state, action) => {
             state.organisations = action.payload ? sortOrganisations(action.payload) : null;
         }
     }
 });

 // these methods only modify the state
 export const { setOrganisations } = organisationSlice.actions;

 // these methods only read the state
 export const getOrganisations = (state: any) => state.organisation.organisations as OrganisationDto[] | null;

 export default organisationSlice.reducer;
